angular.module('impactx.account').controller('AccountCtrl', AccountCtrl);
AccountCtrl.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    'selectedListItems',
    'ToolbarService'
];

function AccountCtrl($scope, dataGen, BackService, $mdToast, ConfirmationService, selectedListItems, ToolbarService) {
    var self = this;
    var accountId = selectedListItems.getFirstSelectedId();

    self.save = function () {
        var dataObj = {
            account: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/account/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    self.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(self.delete, event, $scope.trns.confirmDelete, $scope.trns.delete, $scope.trns.abort);
    };

    self.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.postAsForm($scope, dataObj, "/account/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    self.isEditable = function () {
        return !$scope.data.readOnly
    };

    dataGen.getData($scope, {id: accountId}, "/account/view").then(function () {
        addButtons();
    });

    function addButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: self.isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
            label: $scope.trns.delete,
            action: self.deleteDialog,
            type: 'dialogaction',
            condition: self.isEditable
        }];
        ToolbarService.setButtons(buttonDefinition);
    }
}
